import { ColumnSort } from '@warehouse/title/core';
import { TableColumnSort } from '@warehouse/shared/ui';
import { RelationshipSorters } from '@warehouse/relationships/domain';

export const childrenColumnNames = [
	'titleSearchDisplayNameFull',
	'entryNumber',
	'entryClass',
	'runLength',
	'uuid',
	'releaseDate',
	'sequenceNumber',
	'distributionNumber',
	'houseSequence',
	'editUse',
	'editClasses',
	'madeForRegions',
	'platformSpecification',
	'alid',
	'versionLanguages',
] as const;

export type ChildrenColumnName = (typeof childrenColumnNames)[number];

export function isChildrenColumnName(field: string): field is ChildrenColumnName {
	return (childrenColumnNames as readonly string[]).includes(field);
}

const apiSortFields: Record<Exclude<ChildrenColumnName, 'entryNumber'>, string> = {
	titleSearchDisplayNameFull: 'indexed.titleSearchSortFull',
	entryClass: 'relationship.compilationEntryClass.label',
	runLength: 'indexed.runLength',
	uuid: 'indexed.uuid',
	releaseDate: 'indexed.releaseDate',
	sequenceNumber: 'relationship.sequenceInfo.number',
	distributionNumber: 'relationship.sequenceInfo.distributionNumber.distributionNumber',
	houseSequence: 'relationship.sequenceInfo.houseSequence.houseSequence',
	editUse: 'indexed.editUse',
	editClasses: 'indexed.editClasses',
	madeForRegions: 'indexed.madeForRegions.label',
	platformSpecification: 'indexed.alid.platformSpecification.label',
	alid: 'indexed.alid.identifier',
	versionLanguages: 'indexed.versionLanguages.label',
};

export function childrenSortToApiSort(
	sort: TableColumnSort<ChildrenColumnName>[],
	parentTitleUuid: string,
): ColumnSort[] {
	if (sort.length === 0) {
		return [
			RelationshipSorters.byEntryNumberFromParentCompilation(parentTitleUuid),
			RelationshipSorters.byTitleSearchSortFull(),
		];
	}

	const userSort = sort.map(({ field, sort: direction }) =>
		field === 'entryNumber'
			? RelationshipSorters.byEntryNumberFromParentCompilation(parentTitleUuid, direction === 'desc')
			: { id: apiSortFields[field], desc: direction === 'desc' },
	);
	const titleTieBreaker = RelationshipSorters.byTitleSearchSortFull();
	const isSortedByTitle = userSort.some(({ id }) => id === titleTieBreaker.id);

	return isSortedByTitle ? userSort : [...userSort, titleTieBreaker];
}
